var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.defaultJsonSerializer = void 0;
  exports.defaultJsonSerializer = {
    parse: JSON.parse,
    stringify: JSON.stringify
  }; //# sourceMappingURL=defaultJsonSerializer.js.map

  return exports;
}